import React, { useEffect, useState, useRef } from "react";
import { Bell, AlertTriangle, ShieldAlert, Wheat, Newspaper, X, RefreshCw } from "lucide-react";
import { apiClient } from "../lib/api";

const TYPE_ICON = {
  region: <ShieldAlert size={14} />,
  commodity: <Wheat size={14} />,
  sentiment: <Newspaper size={14} />,
};
const SEV_COLOR = { critical: "#ef4444", warning: "#facc15", info: "#22d3ee" };

export default function AlertsBell() {
  const [open, setOpen] = useState(false);
  const [alerts, setAlerts] = useState([]);
  const [loading, setLoading] = useState(false);
  const [dismissed, setDismissed] = useState(() => {
    try {
      return new Set(JSON.parse(localStorage.getItem("nms_dismissed") || "[]"));
    } catch {
      return new Set();
    }
  });
  const ref = useRef(null);

  const fetchAlerts = async () => {
    setLoading(true);
    try {
      const { data } = await apiClient.get("/alerts");
      setAlerts(data.alerts || []);
    } catch {
      setAlerts([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchAlerts();
    const t = setInterval(fetchAlerts, 5 * 60 * 1000); // every 5 min
    return () => clearInterval(t);
  }, []);

  useEffect(() => {
    if (!open) return;
    const onClick = (e) => {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener("mousedown", onClick);
    return () => document.removeEventListener("mousedown", onClick);
  }, [open]);

  const dismiss = (id) => {
    const next = new Set(dismissed);
    next.add(id);
    setDismissed(next);
    localStorage.setItem("nms_dismissed", JSON.stringify([...next]));
  };

  const visible = alerts.filter((a) => !dismissed.has(a.id));
  const unreadCount = visible.filter((a) => a.severity === "critical" || a.severity === "warning").length;

  return (
    <div className="alerts-bell" ref={ref}>
      <button
        type="button"
        className={`alerts-trigger ${unreadCount > 0 ? "has-unread" : ""}`}
        onClick={() => setOpen((v) => !v)}
        aria-label="Notifikasi"
        data-testid="alerts-trigger"
      >
        <Bell size={16} />
        {unreadCount > 0 && (
          <span className="alerts-badge" data-testid="alerts-badge">{unreadCount > 99 ? "99+" : unreadCount}</span>
        )}
      </button>
      {open && (
        <div className="alerts-pop" data-testid="alerts-pop">
          <header className="ap-head">
            <div>
              <h4>NOTIFIKASI</h4>
              <span>{visible.length} alert aktif</span>
            </div>
            <button onClick={fetchAlerts} title="Refresh" type="button" data-testid="alerts-refresh">
              <RefreshCw size={13} className={loading ? "spin" : ""} />
            </button>
          </header>
          <div className="ap-list">
            {loading && <div className="ap-empty">Memuat alert…</div>}
            {!loading && visible.length === 0 && (
              <div className="ap-empty">
                <AlertTriangle size={22} />
                <span>Tidak ada alert aktif saat ini</span>
                <small>Sistem dalam kondisi stabil</small>
              </div>
            )}
            {visible.map((a) => (
              <div key={a.id} className={`ap-item sev-${a.severity}`} data-testid={`alert-${a.id}`}>
                <span className="ap-icon" style={{ color: SEV_COLOR[a.severity], background: `${SEV_COLOR[a.severity]}1c` }}>
                  {TYPE_ICON[a.type] || <AlertTriangle size={14} />}
                </span>
                <div className="ap-body">
                  <div className="ap-title">{a.title}</div>
                  <div className="ap-msg">{a.message}</div>
                </div>
                <button className="ap-close" onClick={() => dismiss(a.id)} aria-label="Tutup alert" type="button">
                  <X size={12} />
                </button>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}
